"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var browser_sprite_1 = __importDefault(require("svg-baker-runtime/browser-sprite"));
var browser_symbol_1 = __importDefault(require("svg-baker-runtime/browser-symbol"));
var StyledIcon_1 = __importDefault(require("./StyledIcon"));
var renameIds_1 = __importDefault(require("./utilities/renameIds"));
var iconsContainerId = 'thebestco-uikit-svg';
var injectSprite = function () {
    var sprite = new browser_sprite_1.default({
        syncUrlsWithBaseTag: false,
        attrs: { id: iconsContainerId },
    });
    var spriteNode = document.querySelector("#" + iconsContainerId);
    if (spriteNode) {
        sprite.attach(spriteNode);
    }
    else {
        sprite.mount(document.body, true);
    }
    return sprite;
};
var Icon = function (_a) {
    var name = _a.name, getSvg = _a.getSvg, _b = _a.size, size = _b === void 0 ? 16 : _b, _c = _a.width, width = _c === void 0 ? size : _c, _d = _a.height, height = _d === void 0 ? size : _d, rest = __rest(_a, ["name", "getSvg", "size", "width", "height"]);
    var id = iconsContainerId + "-" + name;
    var idSelector = "#" + id;
    (0, react_1.useEffect)(function () {
        if (document.querySelector(idSelector)) {
            return;
        }
        getSvg()
            .then(function (svg) {
            if (document.querySelector(idSelector)) {
                return;
            }
            var sprite = injectSprite();
            sprite.add(new browser_symbol_1.default({ id: id, content: (0, renameIds_1.default)(svg.default, id) }));
        });
    }, []);
    return (react_1.default.createElement(StyledIcon_1.default, __assign({ width: width, height: height, "aria-label": name }, rest),
        react_1.default.createElement("use", { xlinkHref: idSelector })));
};
exports.default = Icon;
